module.exports = __webpack_public_path__ + "img/1531326240.6bc7cea4.jpg";